// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { db, collection, getDocs, updateDoc, doc } from '../firebase';
// import { Container, TextField, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Paper, Grid } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import EditIcon from '@mui/icons-material/Edit';
// import { useAuth } from '../AuthContext';

// const ManagePDFLink = () => {
//   const [pdfLink, setPdfLink] = useState('');
//   const [open, setOpen] = useState(false);
//   const [documentId, setDocumentId] = useState(null);
//   const { currentUser } = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (!currentUser) {
//       navigate('/');
//       return;
//     }
//     fetchPDFLink();
//   }, [currentUser, navigate]);

//   const fetchPDFLink = async () => {
//     const pdfCollection = await getDocs(collection(db, 'pdf'));
//     if (!pdfCollection.empty) {
//       const docData = pdfCollection.docs[0];
//       setPdfLink(docData.data().link || '');
//       setDocumentId(docData.id);
//     }
//   };

//   const handleClickOpen = () => {
//     setOpen(true);
//   };

//   const handleClose = () => {
//     setOpen(false);
//   };

//   const handleSave = async () => {
//     try {
//       if (documentId) {
//         const pdfDoc = doc(db, 'pdf', documentId);
//         await updateDoc(pdfDoc, {
//           link: pdfLink,
//         });
//       } else {
//         console.error('Document ID not found.');
//       }
//       handleClose();
//       fetchPDFLink();
//     } catch (error) {
//       console.error("Error updating PDF link: ", error);
//     }
//   };

//   return (
//     <Container sx={{ paddingTop: '30px', minHeight: '100vh', backgroundColor: '#f5f5f5', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//       <Typography variant="h4" gutterBottom sx={{ marginBottom: '20px', color: '#333' }}>
//         Manage PDF Link
//       </Typography>

//       <Paper elevation={3} sx={{ padding: '20px', width: '100%', maxWidth: '600px', marginBottom: '30px' }}>
//         <Grid container spacing={2} alignItems="center">
//           <Grid item xs={10}>
//             <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
//               Current PDF Link: {pdfLink ? <a href={pdfLink} target="_blank" rel="noopener noreferrer">{pdfLink}</a> : 'No link available'}
//             </Typography>
//           </Grid>
//           <Grid item xs={2}>
//             <IconButton color="primary" onClick={handleClickOpen}>
//               <EditIcon />
//             </IconButton>
//           </Grid>
//         </Grid>
//       </Paper>

//       <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
//         <DialogTitle>
//           Edit PDF Link
//           <IconButton
//             aria-label="close"
//             onClick={handleClose}
//             sx={{
//               position: 'absolute',
//               right: 8,
//               top: 8,
//               color: (theme) => theme.palette.grey[500],
//             }}
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent dividers>
//           <TextField
//             margin="dense"
//             label="PDF Link"
//             type="text"
//             fullWidth
//             variant="outlined"
//             value={pdfLink}
//             onChange={(e) => setPdfLink(e.target.value)}
//             sx={{ marginBottom: '20px' }}
//           />
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleClose} color="secondary" variant="outlined">Cancel</Button>
//           <Button onClick={handleSave} color="primary" variant="contained">Save</Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default ManagePDFLink;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, collection, getDocs, updateDoc, doc } from '../firebase';
import {
  Container,
  TextField,
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Paper,
  Grid,
  Link
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../AuthContext';

const ManagePDFLink = () => {
  const [pdfLink, setPdfLink] = useState('');
  const [pdfLinkS, setPdfLinkS] = useState('');
  const [pdfLinkA, setPdfLinkA] = useState('');
  const [open, setOpen] = useState(false);
  const [documentId, setDocumentId] = useState(null);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!currentUser) {
      navigate('/');
      return;
    }
    fetchPDFLink();
  }, [currentUser, navigate]);

  const fetchPDFLink = async () => {
    const pdfCollection = await getDocs(collection(db, 'pdf'));
    if (!pdfCollection.empty) {
      const docData = pdfCollection.docs[0];
      const data = docData.data();
      setPdfLink(data.link || '');
      setPdfLinkS(data.linkS || '');
      setPdfLinkA(data.linkA || '');
      setDocumentId(docData.id);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = async () => {
    try {
      if (documentId) {
        const pdfDoc = doc(db, 'pdf', documentId);
        await updateDoc(pdfDoc, {
          link: pdfLink,
          linkS: pdfLinkS,
          linkA: pdfLinkA,
        });
      } else {
        console.error('Document ID not found.');
      }
      handleClose();
      fetchPDFLink();
    } catch (error) {
      console.error("Error updating PDF links: ", error);
    }
  };

  return (
    <Container
      sx={{
        paddingTop: '30px',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{ marginBottom: '20px', color: '#333' }}
      >
        Manage PDF Links
      </Typography>

      <Paper elevation={3} sx={{ padding: '20px', width: '100%', maxWidth: '600px', marginBottom: '30px' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <Typography variant="body1" sx={{ wordBreak: 'break-word', marginBottom: '8px' }}>
              Current PDF Link:{' '}
              {pdfLink ? (
                <Link href={pdfLink} target="_blank" rel="noopener noreferrer">
                  {pdfLink}
                </Link>
              ) : (
                'No link available'
              )}
            </Typography>
            <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
              Current PDF LinkS:{' '}
              {pdfLinkS ? (
                <Link href={pdfLinkS} target="_blank" rel="noopener noreferrer">
                  {pdfLinkS}
                </Link>
              ) : (
                'No link available'
              )}
            </Typography>
          </Grid>
          <Grid item xs={12} container justifyContent="flex-end">
            <IconButton color="primary" onClick={handleClickOpen}>
              <EditIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Paper>

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>
          עריכת קישורים
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box sx={{ marginBottom: '20px' }}>
            <TextField
              margin="dense"
              label="הסכמים והתקשריות"
              type="text"
              fullWidth
              variant="outlined"
              value={pdfLink}
              onChange={(e) => setPdfLink(e.target.value)}
            />
          </Box>
          <Box>
            <TextField
              margin="dense"
              label="הסכם ספרים"
              type="text"
              fullWidth
              variant="outlined"
              value={pdfLinkS}
              onChange={(e) => setPdfLinkS(e.target.value)}
            />

            <Box>
              <TextField
                margin="dense"
                label="קטלוג ספרי קודש "
                type="text"
                fullWidth
                variant="outlined"
                value={pdfLinkA}
                onChange={(e) => setPdfLinkA(e.target.value)}
              />
            </Box>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default ManagePDFLink;
